import React from 'react';

function DeleteIcon() {
  return (
    <svg className='rounded text-white p-1 mx-auto' width={35} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'>
      <title>Backspace</title>
      <path
        d='M135.19 390.14a28.79 28.79 0 0021.68 9.86h246.26A29 29 0 00432 371.13V140.87A29 29 0 00403.13 112H156.87a28.84 28.84 0 00-21.67 9.84v0L46.33 256l88.86 134.11z'
        fill='none'
        stroke='currentColor'
        strokeLinejoin='round'
        strokeWidth='32'
      />
      <path
        fill='none'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='32'
        d='M336.67 192.33L206.66 322.34M336.67 322.34L206.66 192.33M336.67 192.33L206.66 322.34M336.67 322.34L206.66 192.33'
      />
    </svg>
  );
}

export default DeleteIcon;
